import moment from "moment-timezone";
import _ from "lodash";

export const tzformat = (date, zone, informat, outformat) => {
  if (!date) {
    return "No date";
  }
  let m;
  const inputDateFormat = informat || "YYYY-MM-DD HH:mm:ss";
  const dateFormat = outformat || inputDateFormat;
  let local;

  if (zone === "UTC") {
    local = moment.utc(date, informat).toDate();
    m = moment(local);
  } else if (zone) {
    m = moment.tz(date, inputDateFormat, zone);
  } else {
    m = moment(date);
  }

  if (m.isValid()) {
    return m.format(dateFormat);
  }
  return "Invalid date";
};

export const tel = (num, type) => {
  if (!num) {
    return "N/A";
  }
  if (type === "TEMP" || type === "GUEST") {
    return "Guest";
  }
  const formatted = num.substr(-10);
  if (formatted.length === 10) {
    return `(${formatted.substr(0, 3)})${formatted.substr(
      3,
      3
    )}-${formatted.substr(-4)}`;
  }
  return num;
};

export const amt = (n, symbol) => {
  let num = n;
  let negative = false;
  let out;

  if (num < 0) {
    negative = true;
    num = Math.abs(num);
  }

  if (num > 0) {
    out = symbol + (num / 100).toFixed(2);
    if (negative) {
      out = `-${out}`;
    }
    return out;
  }

  return `${symbol}0.00`;
};

export const telshort = (phone, type) => {
  let num;
  try {
    if (typeof phone === "string") {
      num = phone;
    } else if (phone && phone.length) {
      num = phone.join("");
    }

    const len = (num && num.length) || "";

    if (type === "GUEST" || type === "TEMP") {
      return "Guest";
    }
    return num.substring(len - 4);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log("Error formatting phone number:", error?.message);
    return "N/A";
  }
};

export const trueFalse = (input) => {
  let inputTrue = true;
  if (!input) {
    inputTrue = false;
  }
  if (input === "0" || input === 0) {
    inputTrue = false;
  }
  if (input === "false") {
    inputTrue = false;
  }
  if (input === "no") {
    inputTrue = false;
  }

  return inputTrue ? "\u2713" : "\u2718";
};

export const cleanForCsv = (txt) =>
  _.isString(txt) ? (txt.trim() ? `"${txt.replace(/"/g, '""')}"` : " ") : txt;

export const toNumber = (num, decimals) => {
  if (num === null || num === undefined) return null;
  if (num === Number.POSITIVE_INFINITY) return "infinity";
  if (num === Number.NEGATIVE_INFINITY) return "-infinity";
  if (Number.isNaN(num)) return "";

  return `${num.toFixed(decimals)}`;
};
